var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCloseCircle(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M12 22C17.5228 22 22 17.5228 22 12C22 6.47715 17.5228 2 12 2C6.47715 2 2 6.47715 2 12C2 17.5228 6.47715 22 12 22Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.06 12.0001L15.36 9.70011C15.65 9.41011 15.65 8.93011 15.36 8.64011C15.07 8.35011 14.59 8.35011 14.3 8.64011L12 10.9401L9.69998 8.64011C9.40998 8.35011 8.92999 8.35011 8.63999 8.64011C8.34999 8.93011 8.34999 9.41011 8.63999 9.70011L10.94 12.0001L8.63999 14.3001C8.34999 14.5901 8.34999 15.0701 8.63999 15.3601C8.78999 15.5101 8.97999 15.5801 9.16999 15.5801C9.35999 15.5801 9.54998 15.5101 9.69998 15.3601L12 13.0601L14.3 15.3601C14.45 15.5101 14.64 15.5801 14.83 15.5801C15.02 15.5801 15.21 15.5101 15.36 15.3601C15.65 15.0701 15.65 14.5901 15.36 14.3001L13.06 12.0001Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloseCircle);
export default __webpack_public_path__ + "static/media/close-circle.d8d447fa7e82a8476425beb56f9e102e.svg";
export { ForwardRef as ReactComponent };